import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

const DotnConnectModal = function ({ showSignal, model }) {

	const isLoading = true //XXX

	const cancelAdd = () => {
		showSignal.value = false
	}

	const exchangeAuthToken = () => {
		window.alert("Entered DotnConnectModal.exchangeAuthToken")
	}

	return (
		<>
			<Modal show={showSignal.value} onHide={cancelAdd}>
				<Modal.Header closeButton>
					<Modal.Title className="modal-title">Connect to DOLLARS ON THE NET</Modal.Title>
				</Modal.Header>
				<Form onClick={exchangeAuthToken} className="form-horizontal newvalidation" role="form" id='AuthCodeEntryForm'>
					<Modal.Body>
						<h4 className='inline-block modal-subhead'>Please use the Authorization Token generated from DOLLARS ON THE NET� to connect this merchant.</h4>
						<Form.Group className="form-group">
							<label htmlFor="authToken" className="col-sm-4 control-label">Authorization Token</label>
							<div className="col-sm-8">
								<input value={model && model.paymentMerchant && model.paymentMerchant.authCode ? model.paymentMerchant.authCode : "Error: Undefined model.paymentMerchant.authCode"} className="form-control" id="authToken" name="authToken" maxLength="50" required={true} />
							</div>
						</Form.Group>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={cancelAdd}>Cancel</Button>
						{
							!isLoading && (<Button className="btn btn-primary submitButtonRight">Add</Button>)
						}
					</Modal.Footer>
				</Form>
			</Modal>
			{/*{partial 'components/prompt-modal'}*/}
		</>
	)
}
export default DotnConnectModal